import { FinancialWorkspaceFinanceFactSummary } from 'generated/resources/graphql'

import { PaginatedTableItem } from 'modules/finance/components/FinancialWorkspace/types/table'
import { DEFAULT_PERIOD } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/hooks/useFinanceSummaries'

export const dataToRow = (
  data: FinancialWorkspaceFinanceFactSummary,
  comparisonData?: FinancialWorkspaceFinanceFactSummary
): PaginatedTableItem => {
  return {
    label: data.label,
    id: Number(data.id),
    data: data.rows.map((row) => ({
      label: row.columnLabel,
      range: row.columnLabel,
      period: DEFAULT_PERIOD,
      totalAmountInCents: row.amountInCents,
      noTotal: false,
    })),
    comparisonData:
      comparisonData?.rows.map((row) => ({
        label: row.columnLabel,
        range: row.columnLabel,
        period: DEFAULT_PERIOD,
        totalAmountInCents: row.amountInCents,
        noTotal: false,
      })) ?? [],
    expanded: false,
  }
}

export const mergeDataAndComparisonData = (
  data?: FinancialWorkspaceFinanceFactSummary[],
  comparisonData?: FinancialWorkspaceFinanceFactSummary[]
): {
  data: FinancialWorkspaceFinanceFactSummary[]
  comparisonData: FinancialWorkspaceFinanceFactSummary[]
} => {
  const dataHash: { [key: string]: FinancialWorkspaceFinanceFactSummary } = {}
  const comparisonDataHash: { [key: string]: FinancialWorkspaceFinanceFactSummary } = {}

  data?.forEach((obj) => {
    if (obj) dataHash[obj.id] = obj
  })

  comparisonData?.forEach((obj) => {
    if (obj) comparisonDataHash[obj.id] = obj
  })

  data?.forEach((obj) => {
    if (obj) comparisonDataHash[obj.id] ||= { ...obj, rows: [] }
  })

  comparisonData?.forEach((obj) => {
    if (obj) dataHash[obj.id] ||= { ...obj, rows: [] }
  })

  return {
    data: Object.values(dataHash).sort((a, b) => a.id.localeCompare(b.id)),
    comparisonData: Object.values(comparisonDataHash).sort((a, b) => a.id.localeCompare(b.id)),
  }
}
